const LoadingButton = () => {
  return (
    <div className="btn-loader-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default LoadingButton;
